import { Badge } from '@/components/ui/badge';

type TokenStatus = 'active' | 'expiring' | 'expired' | 'unknown' | 'permanent';

const STATUS_CONFIG: Record<
  TokenStatus,
  { label: string; variant: 'success' | 'warning' | 'destructive' | 'secondary' }
> = {
  active: { label: 'Active', variant: 'success' },
  expiring: { label: 'Expiring Soon', variant: 'warning' },
  expired: { label: 'Expired', variant: 'destructive' },
  unknown: { label: 'Unknown', variant: 'secondary' },
  permanent: { label: 'Does not expire', variant: 'success' },
};

/** A Facebook Login credential (the Page and its linked account) has no expiry on purpose (AIT-621). */
export function computeTokenStatus(tokenExpiresAt: string | null, connectionType?: string | null): TokenStatus {
  if (!tokenExpiresAt) return connectionType === 'facebook_login' ? 'permanent' : 'unknown';

  const expiresAt = new Date(tokenExpiresAt);
  const daysUntilExpiry =
    (expiresAt.getTime() - Date.now()) / (1000 * 60 * 60 * 24);

  if (daysUntilExpiry <= 0) return 'expired';
  if (daysUntilExpiry <= 7) return 'expiring';
  return 'active';
}

export function TokenStatusBadge({
  tokenExpiresAt,
  connectionType,
}: {
  tokenExpiresAt: string | null;
  connectionType?: string | null;
}) {
  const status = computeTokenStatus(tokenExpiresAt, connectionType);
  const config = STATUS_CONFIG[status];

  return <Badge variant={config.variant}>{config.label}</Badge>;
}
